module.exports = __webpack_public_path__ + "static/media/brain.ce65603a.svg";